import { render } from "./CountryFlag.vue?vue&type=template&id=ab9525bc&scoped=true"
import script from "./CountryFlag.vue?vue&type=script&lang=js"
export * from "./CountryFlag.vue?vue&type=script&lang=js"

import "./CountryFlag.vue?vue&type=style&index=0&id=ab9525bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab9525bc"],['__file',"src/components/CountryFlag.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ab9525bc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ab9525bc', __exports__)) {
    api.reload('ab9525bc', __exports__)
  }
  
  module.hot.accept("./CountryFlag.vue?vue&type=template&id=ab9525bc&scoped=true", () => {
    api.rerender('ab9525bc', render)
  })

}


export default __exports__